import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Icon, IconName } from '@panaya/ui/p-icon';
import { ColorName } from '@panaya/ui/styles-to-code';
import { PDialogFooterBtnActionType } from './p-dialog-footer-btn-config.interface';

// import { getScssColors } from '@common/utils';

@Component({
    selector: 'p-error-dialog',
    template: `
        <p-dialog-container>
            <p-dialog-header
                [iconName]="iconName"
                [iconColor]="iconColor"
                title="{{ headerText }}"
                [isSentenceCase]="isSentenceCase"
            ></p-dialog-header>
            <div class="p-dialog-content simple-dialog-body p-paragraph-1" [innerHTML]="bodyText"></div>
            <p-dialog-footer [btnConfig]="footerConfig"></p-dialog-footer>
        </p-dialog-container>
    `,
    styleUrls: ['./p-error-dialog.component.scss']
})
export class PErrorDialogComponent implements OnInit {
    headerText?: string;
    bodyText?: string;
    iconName?: IconName;
    iconColor!: ColorName;
    isSentenceCase? = true;

    constructor(@Inject(MAT_DIALOG_DATA) public data: PErrorDialogComponentData) {}

    ngOnInit(): void {
        this.headerText = this.data.headerText;
        this.bodyText = this.data.bodyText;
        this.iconName = this.data.icon?.name || 'alert-triangle';
        this.iconColor = this.data.icon?.color || 'status-default-high';
        this.isSentenceCase = this.data.isSentenceCase ?? true;
    }

    get footerConfig() {
        return [
            {
                type: PDialogFooterBtnActionType.Close,
                text: 'Actions.close'
            }
        ];
    }
}

export interface PErrorDialogComponentData {
    headerText: string;
    bodyText: string;
    icon: PErrorDialogComponentIcon;
    isSentenceCase?: boolean;
}

export type PErrorDialogComponentIcon = Pick<Icon, 'name' | 'color'>;
